import { object, shape, array } from "prop-types";
import { WithPreview } from "@quintype/components";
import get from "lodash/get";
import React from "react";

import ScrollToTop from "../atoms/back-to-top-button";
import { GalleryStory } from "../story-templates/gallery-story";
import { PhotoStory } from "../story-templates/photo-story";
import { TextStory } from "../story-templates/text-story";

function StoryPageBase(props) {
  // Can switch to a different template based story-template, or only show a spoiler if index > 0
  const storyTemplate = get(props, ["story", "story-template"], "");

  switch (storyTemplate) {
    case "text":
      return <TextStory {...props} />;
    case "photo":
      return <PhotoStory {...props} />;
    case "video-2":
      return <PhotoStory {...props} />;
    case "gallery":
      return <GalleryStory {...props} />;
    default:
      return <TextStory {...props} />;
  }
}

StoryPageBase.propTypes = {
  story: object,
  relatedStories: array,
};

export function StoryPage(props) {
  return (
    <>
      <StoryPageBase {...props.data} />
      <ScrollToTop />
    </>
  );
}

StoryPage.propTypes = {
  data: shape({
    story: object,
    relatedStories: array,
  }),
};

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story,
    relatedStories: Array(5).fill(story),
    collection: Array(4).fill(story),
  })
);
